import { getQueueTasks } from "../api/EnzianDataApi";
import { handleStoreError } from "./GeneralStore";
import { createSimpleListConfiguration, createSimpleListListFilter } from "../types/ListTypes";
import { _ } from "svelte-i18n";
import { get, writable } from "svelte/store";
export const activeQueueTasks = writable([]);
//This property is used as event bus. Every component can listen for changes here. On the last event will be hold in the store.
export const queueTaskEventBus = writable(null);
export const dismissQueueTask = (queueTask) => {
    activeQueueTasks.update((all) => all.filter((t) => t.id !== queueTask.id));
};
/**
 * Add a queue task to the UI. start a timeout that will check the state of the task.
 * @param queueTask
 */
export const addQueueTask = (queueTask) => {
    // Push the toast to the top of the list of toasts
    activeQueueTasks.update((all) => [queueTask, ...all]);
};
export function createQueueTaskStore() {
    //On component load reset the data
    let queueTaskStore = $state([]);
    let storeListeners = $state([]);
    //Filter for backend
    let listFilter = $state(createSimpleListListFilter({
        localStorageKey: 'queue-task-list',
        filterOptions: [
            {
                label: get(_)('queuetaskview.lbl_date'),
                key: 'creationDate',
                value: null,
                type: 'date'
            },
            {
                label: get(_)('queuetaskview.lbl_success_state'),
                key: 'success',
                value: null,
                type: 'boolean'
            },
            {
                label: get(_)('queuetaskview.lbl_name'),
                key: 'name',
                value: null,
                type: 'string'
            }
        ]
    }));
    let listConfig = $state(createSimpleListConfiguration({
        header: get(_)('queuetaskview.lbl_header'),
        showEmptyAdd: false,
        cardModeConfig: {
            amountOfCols: 5
        }
    }));
    async function loadData() {
        try {
            const queueTasks = await getQueueTasks(listFilter);
            if (listFilter.page == 0) {
                //Reset the data.
                queueTaskStore = queueTasks;
            }
            else {
                //Merge the lists
                queueTaskStore.push(...queueTasks);
            }
            //Increase the page counter.
            if (queueTaskStore.length > 0) {
                listFilter.page += 1;
            }
        }
        catch (error) {
            handleStoreError('queuetaskview.err_load_task', error);
        }
    }
    return {
        get data() { return queueTaskStore; },
        set data(value) { queueTaskStore = value; },
        get listFilter() { return listFilter; },
        set listFilter(value) { listFilter = value; },
        get listConfig() { return listConfig; },
        set listConfig(value) { listConfig = value; },
        addNotifier(listener) {
            storeListeners.push(listener);
        },
        removeNotifier(listener) {
            storeListeners = storeListeners.filter((li) => li == listener);
        },
        loadData: loadData,
        async applyFilter() {
            //Reset the start id
            listFilter.page = 0;
            //Load the data.
            await loadData();
            //Inform the listeners
            storeListeners.forEach((listener) => {
                //Call the event
                listener.onFilterApplied();
            });
        },
        clear() {
            queueTaskStore = [];
        },
    };
}
